import { Component } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Slides } from 'ionic-angular';
import { NavController, LoadingController } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { RegisterPage } from '../register/register';
import { AuthServices } from '../services';


/**
 * Generated class for the LoginPreviewPage page.
 *
 * 
 */

@Component({
  selector: 'page-login-preview',
  templateUrl: 'login-preview.html',
})
export class LoginPreviewPage {

  loadingPopup: any;
  constructor(public navCtrl: NavController,
    public loadingCtrl: LoadingController,
    public splashScreen: SplashScreen,
    public authService: AuthServices) { }

  @ViewChild(Slides) slides: Slides;

  goToSlide() {
    this.slides.slideTo(2, 500);
  }

  openLogin() {
    this.authService.page_show = 'login';
  }

  openRegister() {
    this.navCtrl.setRoot(RegisterPage);
  }

  ionViewDidEnter() {
    this.splashScreen.hide();
  }

}



// WEBPACK FOOTER //
// ./src/pages/auth/login-preview/login-preview.ts